export const SSOProviders = {
  Google: 'Google',
  Facebook: 'Facebook',
};

export default {
  SSOProviders,
};
